export const PanoramaTransactions = {
  altTextOnApply: 'alt-text-on-apply',
  altTextOnGenerateMultipleWithAi: 'alt-text-on-generate-multiple-with-ai',
  altTextOnGenerateSingleWithAi: 'alt-text-on-generate-single-with-ai',
  analyzeSite: 'analyze-site',
  bulkApplyStaticPageAltImage: 'bulk-apply-static-page-alt-image',
  colorContrastRuleOnApply: 'color-contrast-on-apply',
  detectedIssueAnalyzeSite: 'detected-issue-analyze-site',
  fetchDetectedSiteLanguage: 'fetch-detected-site-language',
  headingStructureRuleOnApply: 'heading-structure-on-apply',
  mediaAlternativesOnApply: 'media-alternatives-on-apply',
  reorganizePagesDOMOrder: 'reorganize-page-domain-order',
  setFocusIndicators: 'set-focus-indicators-on-apply',
  siteLanguageRuleOnApply: 'site-language-on-apply',
  skipToMainContentRule: 'skip-to-main-content-on-apply',
  suppressIncompleteElement: 'suppress-incomplete-element',
  validStaticPageNameOnApply: 'get-valid-static-page-name-on-apply',
  welcomeScreenAnalyzeSite: 'welcome-screen-analyze-site'
};
export const PanoramaErrorNames = {
  altTextOnGenerateMultipleWithAi: 'alt-text-on-generate-multiple-with-ai',
  altTextOnGenerateSingleWithAi: 'alt-text-on-generate-single-with-ai',
  analyzeSite: 'analyze-site',
  headingStructureOnApply: 'heading-structure-on-apply',
  navigateToPage: 'navigate-to-page',
  reorganizePagesDOMOrder: 'reorganize-page-domain-order-error',
  setFocusIndicators: 'set-focus-indicators',
  skipToMainContent: 'skip-to-main-content',
  suppressIncompleteElement: 'suppress-incomplete-element',
  updateAltText: 'update-alt-text',
  updateMediaAlternatives: 'update-media-alternatives',
  updatePageName: 'update-page-name',
  updateSiteLanguage: 'update-site-language'
};
//# sourceMappingURL=constants.js.map